
const OfferTypes = [
    {
        title: 'basic',
        price: 'brak opłat',
        displayTime: 30,
        refreshes: 0
    },
    {
        title: 'basic+',
        price: 39,
        displayTime: 30,
        refreshes: 1
    },
    {
        title: 'premium',
        price: 159,
        displayTime: 30,
        refreshes: 1
    },
    {
        title: 'PakietPremium10',
        price: 100
    },
    {
        title: 'PakietPremium30', 
        price: 200
    },
    {
        title: 'PakietPremium50',
        price: 300
    }
]

export default OfferTypes;
